/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import { productTileStyles } from "@monsma/App/Components/ProductTile/ProductTile";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

export const slashText = {
    color: "common.ui24",
    size: 16,
    css: css`
        padding-right: 30px;
        align-items: center;
        display: inline-flex;
    `,
};

export const notesStyles = {
    wrapper: {
        css: css`
            display: block;
            width: 100%;
            padding: 10px 20px;
            margin-top: 15px;
            border-radius: 2px;
            background-color: ${getColor("common.ui21")};
            border-radius: 6px;

            ${screen("lte", "md")} {
                margin-bottom: 20px;
            }
        `,
    },
    heading: {
        css: css`
            font-size: 13px;
            text-transform: capitalize;
            margin-right: 5px;
            display: inline;
        `,
    },
    text: {
        css: css`
            display: inline;
            line-height: 18px;
            font-size: 13px;
        `,
    },
};

export const notesWrapper = {
    css: css`
        width: 100%;
    `,
};

export const actionsAndNotesWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

export const extendedProductTileStyles = {
    productTileWrapper: {
        css: css`
            border: 0;

            &&&.list-view {
                padding: 0;

                ${screen("gt", "md")} {
                    width: calc(100% - 80px);
                }

                @media print {
                    page-break-inside: avoid;

                    &:after {
                        content: "";
                        clear: both;
                        display: table;
                    }
                }
            }
        `,
    },
    bottomSection: {
        css: css`
            &.list-view {
                display: flex;
                flex-direction: column;

                @media print {
                    width: auto;
                }

                ${screen("lte", "md")} {
                    margin-top: 10px;
                }
            }
        `,
    },
    productPriceWrapper: {
        css: css`
            flex-grow: 0;
        `,
    },
};
